export default __webpack_public_path__ + "55305d3f34fb98d61ee074b7fc0be919.svg";